<div class="time-series-chart" #container>
  <highcharts-chart
    [Highcharts]="Highcharts"
    [options]="options"
    [callbackFunction]="chartCallback"
  >
  </highcharts-chart>
</div>
